import { useEffect, useState } from "react";

/**
 * Suspense fallback for the lazy tabs — invisible for its first 180ms.
 *
 * Aug 21 2026. React.lazy suspends on a chunk's FIRST render even when the
 * chunk was pre-warmed and the import promise is already resolved — a 1-2
 * frame suspension. With an eager spinner those frames paint as a spinner
 * pop directly before the tab's own fade: the second half of the Tasks-tab
 * "double flash" (frame-sampled probe, session notes). Rendering nothing for
 * 180ms means a warm resolve shows only the shared #F0F0FF background —
 * imperceptible — while a genuinely slow first load (cold WKWebView, bad
 * network) still gets its spinner once the delay passes.
 */
const TabLoader = () => {
  const [pastDelay, setPastDelay] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setPastDelay(true), 180);
    return () => window.clearTimeout(t);
  }, []);
  if (!pastDelay) return null;
  return (
    <div
      className="flex-1 flex items-center justify-center"
      style={{ backgroundColor: "#F0F0FF" }}
    >
      <span
        className="animate-spin rounded-full h-8 w-8 border-2"
        style={{ borderColor: "#5050C8", borderTopColor: "transparent" }}
      />
    </div>
  );
};

export default TabLoader;
